import React from 'react'
import NavBar from './Navbar'
import { Outlet } from 'react-router'
import NavMenu from './NavMenu'

const WithNav = () => {
  return (
    <>
      <NavBar />
      <NavMenu />
      <Outlet />
    </>
  )
}

export default WithNav
